import UserProfile from "../../components/features/user-profile/UserProfile";

const UserProfilePage = () => {
  return <UserProfile />;
};

export default UserProfilePage;
